// Matriz de permisos para los menús principales del dashboard
export const permisosMenusDashboard = {
  dashboard: [
    'terapeuta', 'coord_programa', 'coord_ceseco', 'direccion', 'admin'
  ],
  contacto: [
    'secretaria', 'terapeuta', 'coord_programa', 'coord_ceseco', 'direccion', 'admin'
  ],
  categorias: [
    'coord_programa', 'coord_ceseco', 'direccion', 'admin'
  ],
  servicios: [
    'coord_programa', 'coord_ceseco', 'direccion', 'admin'
  ],
  turnos: [
    'terapeuta', 'admin'
  ],
  citas: [
    'secretaria', 'coord_programa', 'coord_ceseco', 'direccion', 'admin'
  ],
  disponibilidad: [
    'terapeuta', 'coord_programa', 'coord_ceseco', 'direccion', 'admin'
  ],
  banners: [
    'coord_programa', 'coord_ceseco', 'direccion', 'admin'
  ],
  usuarios: [
    'coord_programa', 'coord_ceseco', 'direccion', 'admin'
  ],
  reportes: [
    'direccion', 'admin', 'coord_ceseco'
  ],
  talleres: [
    'coord_programa', 'coord_ceseco', 'direccion', 'admin'
  ],
  'citas-talleres': [
    'secretaria', 'coord_programa', 'coord_ceseco', 'direccion', 'admin'
  ]
};

export function puedeVerMenu(rol, menu) {
  return permisosMenusDashboard[menu]?.includes(rol);
} 